import { Box, Grid, Typography } from '@mui/material';
import { DefinedUseQueryResult } from '@tanstack/react-query';
import { map } from 'lodash';
import { useParams } from 'react-router-dom';
import ExpandableBox from 'src/components/common/ExpandableBox';
import LoadingSkeleton from 'src/components/common/LoadingSkeleton';
import WhiteBoxContent from 'src/components/common/WhiteBoxContent';
import { CommonResponseList } from 'src/model/common';

const RelatedQuestion = ({
  reviewRelatedQuestion,
}: {
  reviewRelatedQuestion: DefinedUseQueryResult<CommonResponseList, Error>;
}) => {
  const { id } = useParams();
  const {
    data: { data },
    isFetching,
  } = reviewRelatedQuestion;

  const renderContent = () => {
    if (isFetching)
      return (
        <Grid item xs={12}>
          <LoadingSkeleton count={10} sx={{ height: 50 }} />;
        </Grid>
      );

    return map(data, ({ question, id, title, text, url }) => (
      <Grid xs={6} item key={id}>
        <ExpandableBox openDefault={false} title={question}>
          <Box p={2}>
            <a href={url} target="_blank">
              <Typography mb={1} variant="subtitle1" color={'secondary.main'}>
                {title}
              </Typography>
            </a>
            <Typography variant="body2" color={'text.secondary'}>
              {text}
            </Typography>
          </Box>
        </ExpandableBox>
      </Grid>
    ));
  };

  return (
    <WhiteBoxContent>
      <Typography mb={3} variant="h5">
        People Also Ask
      </Typography>

      <Grid container columnSpacing={3} rowSpacing={2}>
        {renderContent()}
      </Grid>
    </WhiteBoxContent>
  );
};

export default RelatedQuestion;
